// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAJflYu0MdQtG0aeMtrwv-ume9L3Gm3kEM",
  authDomain: "dodge-game-af680.firebaseapp.com",
  projectId: "dodge-game-af680",
  storageBucket: "dodge-game-af680.firebasestorage.app",
  messagingSenderId: "605762507334",
  appId: "1:605762507334:web:fa4c31c07136313475b047"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);